import { createSelector, type MemoizedSelector } from '@ngrx/store';

import { type PageContext } from '@blaze-shared/projects-domain';

import { pageContextFeature } from './page-context.reducer';

export const selectPageContextById = (
  pageContextId: string,
): MemoizedSelector<
  Record<string, any>,
  PageContext,
  (s1: Record<string, PageContext>) => PageContext
> =>
  createSelector(pageContextFeature.selectPageContextEntities, (pageContext) => {
    return pageContext[pageContextId];
  });

export const selectPageContextByPageId = (
  pageId: string,
): MemoizedSelector<
  Record<string, any>,
  PageContext | undefined,
  (s1: Record<string, PageContext>) => PageContext | undefined
> =>
  createSelector(pageContextFeature.selectPageContextEntities, (pageContextEntities) => {
    return Object.values(pageContextEntities).find((pc) => pc.pageId === pageId);
  });
